import { useState, useEffect } from 'react';

const useUserIPLocation = () => {
  const [isUSA, setIsUSA] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLocation = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        setIsUSA(data.country_code === 'US');
      } catch (error) {
        setIsUSA(false);
      } finally {
        setLoading(false);
      }
    };

    checkLocation();
  }, []);

  return { isUSA, loading };
};

export default useUserIPLocation;
